/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prescription_Reason_Same_Muscle_Other_EquipmentInputs */

const en_us2_prescription_reason_same_muscle_other_equipment = /** @type {(inputs: Prescription_Reason_Same_Muscle_Other_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Works the same muscle on different equipment`)
};

const pt_br2_prescription_reason_same_muscle_other_equipment = /** @type {(inputs: Prescription_Reason_Same_Muscle_Other_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalha o mesmo músculo em outro equipamento`)
};

const es_419_prescription_reason_same_muscle_other_equipment = /** @type {(inputs: Prescription_Reason_Same_Muscle_Other_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabaja el mismo músculo con otro equipo`)
};

const pt_pt2_prescription_reason_same_muscle_other_equipment = /** @type {(inputs: Prescription_Reason_Same_Muscle_Other_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalha o mesmo músculo noutro equipamento`)
};

const fr_fr2_prescription_reason_same_muscle_other_equipment = /** @type {(inputs: Prescription_Reason_Same_Muscle_Other_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Travaille le même muscle avec un autre matériel`)
};

const de_de2_prescription_reason_same_muscle_other_equipment = /** @type {(inputs: Prescription_Reason_Same_Muscle_Other_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainiert denselben Muskel an anderer Ausrüstung`)
};

const it_it2_prescription_reason_same_muscle_other_equipment = /** @type {(inputs: Prescription_Reason_Same_Muscle_Other_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavora lo stesso muscolo con un altro attrezzo`)
};

/**
* | output |
* | --- |
* | "Works the same muscle on different equipment" |
*
* @param {Prescription_Reason_Same_Muscle_Other_EquipmentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_reason_same_muscle_other_equipment = /** @type {((inputs?: Prescription_Reason_Same_Muscle_Other_EquipmentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Reason_Same_Muscle_Other_EquipmentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_reason_same_muscle_other_equipment(inputs)
	if (locale === "es-419") return es_419_prescription_reason_same_muscle_other_equipment(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_reason_same_muscle_other_equipment(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_reason_same_muscle_other_equipment(inputs)
	if (locale === "de-DE") return de_de2_prescription_reason_same_muscle_other_equipment(inputs)
	if (locale === "it-IT") return it_it2_prescription_reason_same_muscle_other_equipment(inputs)
	return en_us2_prescription_reason_same_muscle_other_equipment(inputs)
});
export { prescription_reason_same_muscle_other_equipment as "prescription.reason.same_muscle_other_equipment" }